import type { HTTPMethod } from '@/types/general'
import type { Component } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export enum LinkType {
  External,
  Route,
  Request
}

interface ExternalUrl {
  type: LinkType.External
  url: string
}

interface Route {
  type: LinkType.Route
  route: RouteLocationRaw
}

interface Request {
  type: LinkType.Request
  url: string
  method: HTTPMethod
}

export interface NavigationItem {
  link: ExternalUrl | Route | Request | null
  icon: Component
  i18nLabel: string
  discount?: number
  notification?: boolean
  callback?: Function
  hide?: boolean
}

export interface NavigationActionItem {
  title: string
  icon: Component
  description?: string
  link?: string
  i18nLabel?: string
  callback?: Function
  hide?: boolean
}

export enum RouteNames {
  ClaimReport = 'claim_report',
  ContractModification = 'contract_modification'
}
